/*eslint-disable*/
import React, { useState, useEffect, useContext } from 'react'
import { components } from 'react-select'
import { useParams } from 'react-router-dom'
import Select from 'components/Select'
import CheckBox from 'components/Checkbox'
import SearchIcon from 'assets/icons/search-icon'
import Button from 'components/Button'
import InfoIcon from 'assets/icons/info-icon16px'
import {
  Label,
  MultiSelectDropdownContainer,
  MultiSelectIconContainer,
  MultiSelectIconWrapper,
  MultiSelectInputWrapper
} from './style'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import { SiteContext } from 'providers/site'
import { MenuListActions, MenuListFooter, MenuOption } from 'components/2StepMultiSelectionDropdown/components/MenuList/style'
import { D1a_Value, D1b_Value } from 'flow/siteProposal/pages/assessment/components/speciesDetails/speciesDetailsModal/components/constants'

const selectAllValue = 0
const formatSecondStepOptions = (options, secondStepSelection) => {
  const d1bExists = secondStepSelection.some((selectedOption) => selectedOption.value === D1b_Value)
  const d1aExists = secondStepSelection.some((selectedOption) => selectedOption.value === D1a_Value)
  if (d1bExists) {
    const d1bNoContent = options.filter((selectedOption) => selectedOption.value !== D1a_Value)
    return d1bNoContent.map((option) => {
      const isChecked = secondStepSelection.some((selectedOption) => selectedOption.value === option.value)
      return {
        label: (
          <MenuOption disabled={option.disabled}>
            <CheckBox checked={isChecked} disabled={option.disabled} /> {option.label}
          </MenuOption>
        ),
        initialLabel: option.label,
        value: option.value,
        isChecked: isChecked,
        disabled: option.disabled
      }
    })
  }
  if (d1aExists) {
    const d1aNoContent = options.filter((selectedOption) => selectedOption.value !== D1b_Value)
    return d1aNoContent.map((option) => {
      const isChecked = secondStepSelection.some((selectedOption) => selectedOption.value === option.value)
      return {
        label: (
          <MenuOption disabled={option.disabled}>
            <CheckBox checked={isChecked} disabled={option.disabled} /> {option.label}
          </MenuOption>
        ),
        initialLabel: option.label,
        value: option.value,
        isChecked: isChecked,
        disabled: option.disabled
      }
    })
  }
  return options.map((option) => {
    const isChecked = secondStepSelection.some((selectedOption) => selectedOption.value === option.value)
    return {
      label: (
        <MenuOption disabled={option.disabled}>
          <CheckBox checked={isChecked} disabled={option.disabled} /> {option.label}
        </MenuOption>
      ),
      initialLabel: option.label,
      value: option.value,
      isChecked: isChecked,
      disabled: option.disabled
    }
  })
}
const getSingleValueString = (options, fullWidthSelect) => {
  const maxLength = fullWidthSelect ? 120 : 45
  return options.reduce(
    (acc, cur) => {
      const test = [...acc.show, cur]
      if (test.join(', ').length <= maxLength || acc.show.length === 0) {
        acc.show.push(cur)
      } else {
        acc.rest.push(cur)
      }
      return acc
    },
    { show: [], rest: [] }
  )
}
const SecondStepSingleValue = (secondStepSelection, placeholder, fullWidthSelect) => (props) => (
  <components.SingleValue {...props}>
    {secondStepSelection.length === 0 && (
      <span>
        <FormattedMessage id={placeholder} />
      </span>
    )}
    {secondStepSelection.length === 1 && <span>{secondStepSelection[0].initialLabel}</span>}
    {secondStepSelection.length > 1 && (
      <span title={secondStepSelection.map((item) => item.initialLabel).join(', ')}>
        {getSingleValueString(
          secondStepSelection.map((item) => item.initialLabel),
          fullWidthSelect
        ).show.join(', ')}
        {getSingleValueString(
          secondStepSelection.map((item) => item.initialLabel),
          fullWidthSelect
        ).rest.length !== 0
          ? `, + ${
              getSingleValueString(
                secondStepSelection.map((item) => item.initialLabel),
                fullWidthSelect
              ).rest.length
            }`
          : ''}
      </span>
    )}
  </components.SingleValue>
)
const SecondStepMenuList = (secondStepSelection, cancelAction, doneAction, disable) => (props) => (
  <div>
    <components.MenuList className="scroll" {...props} />
    <MenuListFooter>
      <span>{secondStepSelection.length} selected</span>
      <MenuListActions>
        <div style={{ marginRight: '16px' }}>
          <Button height="40px" marginTop="0px" onClick={cancelAction} type="secondary">
            Cancel
          </Button>
        </div>
        <Button
          height="40px"
          marginTop="0px"
          onClick={doneAction}
          type={disable ? 'disabledPrimary' : 'primary'}
          isDisabled={disable}
        >
          Apply
        </Button>
      </MenuListActions>
    </MenuListFooter>
  </div>
)
const MonitoringAboutMultiSelect = ({
  label,
  value = [],
  secondStepOptions = [],
  saveChanges,
  marginBottom = '32px',
  marginBottomLabel,
  marginTop,
  valueChecked,
  infoTooltip,
  zIndex,
  height,
  error = { field: '', error: '' },
  field,
  disabled,
  menuWidth = '100%',
  placeholder = 'selectMultipleOptions',
  isOptional = false,
  inputValue,
  onInputChange,
  isSearchable = false,
  selectAllOption = false,
  errorMarginTop = '16px',
  closeFunc,
  dataTest,
  fullWidthSelect = false,
  menuPlacement,
  maxMenuHeight = 200,
}) => {
  const params = useParams()
  const { site } = useContext(SiteContext) // Use the SiteContext
  const withSecondStep = !!secondStepOptions.length
  const initialSecondStepSelection = withSecondStep
    ? secondStepOptions
        .filter((option) => value.includes(option.value))
        .map((option) => ({ ...option, initialLabel: option.label }))
    : []
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [secondStepSelection, setSecondStepSelection] = useState(initialSecondStepSelection)
  const onFocusHandler = () => {
    if (!disabled) setMenuIsOpen(true)
  }
  const onBlurHandler = () => {
    setMenuIsOpen(false)
    if (closeFunc) closeFunc()
  }
  const secondStepOptionsFormatted = formatSecondStepOptions(secondStepOptions, secondStepSelection)
  const checkedValues = secondStepOptionsFormatted.map((item) => ({
    value: item.value,
    checked: item.isChecked,
    itemLabel: item.label
  }))
  if (valueChecked) valueChecked(checkedValues)
  const isAllOptionsAlreadyChecked = secondStepOptions.length === secondStepSelection.length
  let disableApplyBtn
  if (site != undefined) {
    if (params?.monitoringId != undefined) {
    } else {
      disableApplyBtn =
        initialSecondStepSelection
          .map((item) => item.value)
          .sort()
          .toString() ===
          secondStepSelection
            .map((item) => item.value)
            .sort()
            .toString() || site.SiteStatusId !== SITE_STATUS_DRAFT_ID
    }
  } else {
    disableApplyBtn =
      initialSecondStepSelection
        .map((item) => item.value)
        .sort()
        .toString() ===
      secondStepSelection
        .map((item) => item.value)
        .sort()
        .toString()
  }
  const cancelAction = (e) => {
    setSecondStepSelection(initialSecondStepSelection)
    e.stopPropagation()
    setMenuIsOpen(false)
    if (closeFunc) closeFunc()
  }
  const saveAction = (e) => {
    saveChanges(secondStepSelection.map((option) => option.value))
    e.stopPropagation()
    setMenuIsOpen(false)
  }
  const styledFilterOption = (option, query) => String(option?.data?.initialLabel ?? '').toLowerCase().includes(String(query ?? '').toLowerCase())
  useEffect(() => {
    setSecondStepSelection(
      secondStepOptions
        .filter((option) => value.includes(option.value))
        .map((option) => ({ ...option, initialLabel: option.label }))
    )
  }, [value])
  useEffect(() => {
    if (inputValue) setMenuIsOpen(true)
  }, [inputValue])
  return (
    <MultiSelectDropdownContainer data-testid="test-multi-select-dropdown" marginBottom={marginBottom}>
      <Label marginBottomLabel={marginBottomLabel}>
        <section style={{ display: 'flex', alignItems: 'center' }}>
          <FormattedMessage id={label} />
          {infoTooltip && (
            <Tooltip
              style={{ zIndex: 2000 }}
              zIndex={zIndex}
              placement="top"
              trigger={['hover']}
              align={{ offset: [0, -16] }}
              overlay={{ label, infoTooltip }}
            >
              <div>
                <InfoIcon />
              </div>
            </Tooltip>
          )}
        </section>
        <span>{isOptional && <FormattedMessage id="optional" />}</span>
      </Label>
      <MultiSelectInputWrapper
        data-test={dataTest}
        marginTop={marginTop}
        onClick={(e) => {
          e.stopPropagation()
          onFocusHandler()
        }}
      >
        {isSearchable && (
          <MultiSelectIconContainer>
            <MultiSelectIconWrapper>
              <SearchIcon />
            </MultiSelectIconWrapper>
          </MultiSelectIconContainer>
        )}
        <Select
          marginBottom="0px"
          height={height}
          closeMenuOnSelect={false}
          errorMarginTop={errorMarginTop}
          error={error}
          field={field}
          menuIsOpen={menuIsOpen}
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          disabled={disabled}
          menuWidth={menuWidth}
          menuPlacement={menuPlacement}
          maxMenuHeight={maxMenuHeight}
          inputValue={inputValue}
          onInputChange={onInputChange}
          isSearchable={isSearchable}
          filterOption={styledFilterOption}
          paddingLeft={isSearchable ? '30px' : '8px'}
          singleValueComponent={SecondStepSingleValue(secondStepSelection, placeholder, fullWidthSelect)}
          menuListComponent={SecondStepMenuList(secondStepSelection, cancelAction, saveAction, disableApplyBtn)}
          value={value.length ? { label: 'Yes', value: 1 } : { label: 'No', value: 0 }}
          options={
            secondStepOptions.length > 0 && selectAllOption
              ? [
                  {
                    label: (
                      <MenuOption>
                        <CheckBox checked={isAllOptionsAlreadyChecked} /> Select All
                      </MenuOption>
                    ),
                    value: selectAllValue,
                    initialLabel: ''
                  },
                  ...secondStepOptionsFormatted
                ]
              : secondStepOptionsFormatted
          }
          onChange={(e) => {
            const selectAllChecked = e.value === selectAllValue
            if (selectAllChecked) {
              const newSelection = isAllOptionsAlreadyChecked ? [] : secondStepOptionsFormatted
              setSecondStepSelection(newSelection)
              // Call onInputChange if provided for real-time updates
              if (onInputChange) {
                onInputChange(newSelection.map((option) => option.value))
              }
              return
            }
            const isSelectedOptionAlreadyChecked = secondStepSelection.some((option) => option.value === e.value)
            setSecondStepSelection((s) => {
              let newSelection
              if (!e.disabled && !isSelectedOptionAlreadyChecked) {
                newSelection = [...s, e]
              } else {
                newSelection = s.filter((option) => option.value !== e.value)
              }
              // Call onInputChange if provided for real-time updates
              if (onInputChange) {
                onInputChange(newSelection.map((option) => option.value))
              }
              return newSelection
            })
          }}
        />
      </MultiSelectInputWrapper>
    </MultiSelectDropdownContainer>
  )
}
export default MonitoringAboutMultiSelect
